import React from 'react';
import { BBModel, StorySymbols } from 'types/story';
import { Context } from 'client/components/common/ResponsiveProvider/Context';
import StylesRenderer from './StylesRenderer';

const { Consumer } = Context;

type Props = {
	elements: BBModel[];
	isCardTree: boolean;
	isEditor: boolean;
	symbols?: StorySymbols;
};

const Styles = (props: Props) => (
	<Consumer>
		{({ mediaQuery }) =>
			mediaQuery && (
				<StylesRenderer
					isCardTree={props.isCardTree}
					elements={props.elements}
					mediaQuery={mediaQuery}
					isEditor={props.isEditor}
					symbols={props.symbols}
				/>
			)
		}
	</Consumer>
);

Styles.defaultProps = {
	symbols: null,
};

export default Styles;
